import React, { forwardRef } from 'react';
import { BaseButton } from './BaseButton';
import { useTheme } from '../ThemeProvider/useTheme';
const SecondaryButtonComponent = (props, ref) => {
    const theme = useTheme();
    return (React.createElement(BaseButton, Object.assign({ ref: ref, color: theme.colors.content.above.secondary }, props)));
};
export const SecondaryButton = forwardRef(SecondaryButtonComponent);
